import gql from 'graphql-tag';
import OFFER_ORDER_FRAGMENT from '../f/order';

export default gql`
  query offersCart {
    offersCart {
      ...OfferOrderFragment
    }
  }
  ${OFFER_ORDER_FRAGMENT}
`;



// WEBPACK FOOTER //
// ./app/containers/Lite/gql/q/offersCart.js